<main class="checkout-container" id="page_checkout">
  <!-- Header Section -->
  <header class="checkout-header">
    <div class="header-content">
      <!-- Main Logo - Centered on mobile -->
      <div class="main-logo">
        <img src="assets/img/logo-tix.png" alt="TIX" class="tix-logo" />
      </div>

      <!-- Timer Section -->
      <div class="timer-section" *ngIf="timeoutMinutes >= 0">
        <div class="timer-content">
          <div class="timer-logo">
            <img src="assets/img/logo-tix.png" alt="TIX" class="tix-logo" />
          </div>
          <div class="timer-display">
            <div class="timer-time">
              {{
                timeoutMinutes >= 10 ? timeoutMinutes : '0' + timeoutMinutes
              }}:{{
                timeoutSeconds >= 10 ? timeoutSeconds : '0' + timeoutSeconds
              }}
            </div>
            <div class="timer-text">
              Tiempo restante para completar la orden
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content Grid -->
  <div class="checkout-main-grid" [class.free-event-layout]="eventFree">
    <!-- Left Column - Contact and Payment Information -->
    <section class="checkout-left-column" [class.free-event-left]="eventFree">
      <div class="checkout-content">
        <div class="sections-container">
          <!-- Contact Information Section -->
          <section class="contact-section">
            <h2 class="section-title">Datos de Contacto</h2>
            <form class="contact-form">
              <div class="form-row">
                <div class="form-group">
                  <label for="nameInput">Nombre Completo</label>
                  <input
                    type="text"
                    class="form-input"
                    [ngClass]="{ 'is-invalid': shouldShowNameError() }"
                    id="nameInput"
                    name="nameInput"
                    placeholder="James Bond"
                    [(ngModel)]="buyerData.name"
                    (blur)="validationTouched.name = true"
                    (input)="onNameInput($any($event.target).value)"
                  />
                  <div class="error-text" *ngIf="shouldShowNameError()">
                    El nombre es requerido
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label for="emailInput">Email</label>
                  <input
                    type="email"
                    class="form-input"
                    [ngClass]="{
                      'is-invalid': isEmailInvalid && emailInput.touched
                    }"
                    id="emailInput"
                    name="emailInput"
                    placeholder="james007@gmail.com"
                    autocomplete="off"
                    [formControl]="emailInput"
                    required
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="isEmailInvalid && emailInput.touched"
                  >
                    Este correo no es válido
                  </div>
                </div> -->
                <div class="form-group">
                  <label for="emailInput">Email o Número de telefono</label>
                  <app-smart-input
                    [formControl]="emailInput"
                    [ngClass]="{ 'is-invalid': shouldShowEmailError() }"
                    (valueChange)="onContactoChange($event)"
                    (modeChange)="onModeChange($event)"
                    (blur)="validationTouched.email = true"
                    allowedTypes="both"
                  ></app-smart-input>
                </div>
              </div>

              <!-- Free Event Button Section -->
              <div class="free-event-action mt-4" *ngIf="eventFree">
                <button
                  class="btn btn-primary btn-receive-tickets more-rounded"
                  type="button"
                  (click)="receiveFreeTickets()"
                  [disabled]="!isFormValid()"
                  style="
                    min-height: 38px !important;
                    max-height: 38px !important;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  Recibir Tickets
                </button>
                <p class="terms-text">
                  Al realizar esta compra usted acepta los
                  <strong
                    role="button"
                    tabindex="0"
                    data-bs-toggle="modal"
                    data-bs-target="#usageTerms"
                    >Términos de uso</strong
                  >
                  y las
                  <strong
                    role="button"
                    tabindex="0"
                    data-bs-toggle="modal"
                    data-bs-target="#returnPolicies"
                    >Políticas de devolución</strong
                  >
                </p>
                <p class="recaptcha-terms">
                  Este sitio está protegido por reCAPTCHA
                </p>
              </div>
            </form>
          </section>

          <!-- Payment Information Section -->
          <section class="payment-section" *ngIf="!eventFree">
            <div class="section-header">
              <h2 class="section-title">Información de pago</h2>
              <div
                class="payment-tooltip"
                (mouseenter)="showTooltip($event, 'tooltip-bubble')"
                (mouseleave)="hideTooltip($event, 'tooltip-bubble')"
                (touchstart)="showTooltipTouch($event, 'tooltip-bubble')"
                (touchend)="hideTooltipTouch($event, 'tooltip-bubble')"
              >
                <span class="material-symbols-outlined info-icon">info</span>
                <div class="tooltip-bubble">
                  <span class="tooltip-text">Pago seguro con</span>
                  <img
                    src="assets/img/AZULLogo.png"
                    alt="Azul"
                    class="azul-logo"
                  />
                </div>
              </div>
            </div>

            <!-- Digital Wallet Buttons -->
            <div class="payment-methods">
              <!-- TODO: Habilitar pago con wallet DEBAJO -->
              <app-pay-with-wallet
                [amount]="
                  (paymentInfo.secured
                    ? orderPrice.securedTotal
                    : orderPrice.total
                  ).toString()
                "
                [label]="event.name"
                [type]="'final'"
                (loadPaymentData)="onLoadPaymentData($event)"
                [paymentStatus]="paymentStatus"
              ></app-pay-with-wallet>
            </div>

            <!-- Card Payment Section -->
            <div class="card-payment">
              <!-- <h3 class="card-payment-title">Pagar con tarjeta</h3> -->
              <p class="card-payment-subtitle subtitle-gray">
                Detalles de tarjeta
              </p>

              <form class="card-form">
                <!-- Desktop Design - Original layout -->
                <div class="card-details-row">
                  <div class="form-group card-number-group">
                    <div style="position: relative">
                      <span
                        class="material-symbols-outlined card-icon"
                        *ngIf="!detectedCardBrand"
                        >credit_card</span
                      >
                      <img
                        *ngIf="detectedCardBrand === 'visa'"
                        class="brand-icon"
                        src="assets/img/type-visa-card.png"
                        alt="Visa"
                      />
                      <img
                        *ngIf="detectedCardBrand === 'mastercard'"
                        class="brand-icon"
                        src="assets/img/type-mastercard-card.png"
                        alt="Mastercard"
                      />
                      <img
                        *ngIf="detectedCardBrand === 'amex'"
                        class="brand-icon"
                        src="assets/img/type-amex-card.png"
                        alt="Amex"
                      />
                      <img
                        *ngIf="detectedCardBrand === 'discover'"
                        class="brand-icon discover-icon"
                        src="assets/img/discover_card-logo.png"
                        alt="Discover"
                      />
                      <input
                        type="tel"
                        inputmode="numeric"
                        autocomplete="cc-number"
                        class="form-input card-number"
                        [ngClass]="{
                          'is-invalid': shouldShowCardNumberError()
                        }"
                        mask="0000 0000 0000 0000"
                        placeholder="1234 5678 9012 3456"
                        name="cardNumber"
                        [(ngModel)]="paymentInfo.card"
                        (ngModelChange)="onCardInput($event)"
                        (focusout)="
                          searchCardDiscounts(); validationTouched.card = true
                        "
                      />
                    </div>
                    <div class="error-text" *ngIf="shouldShowCardNumberError()">
                      Ingrese un número de tarjeta válido
                    </div>
                  </div>
                  <div class="form-group expiration-date-group">
                    <input
                      type="tel"
                      inputmode="numeric"
                      autocomplete="cc-exp"
                      class="form-input"
                      [ngClass]="{
                        'is-invalid': shouldShowExpirationDateError()
                      }"
                      mask="00/00"
                      placeholder="MM/AA"
                      name="expDate"
                      [(ngModel)]="paymentInfo.expDate"
                      (ngModelChange)="onExpDateInput($event)"
                      (keyup)="onExpDateKeyUp($event)"
                      (blur)="validationTouched.expDate = true"
                    />
                    <!-- Simple error text -->
                    <div
                      class="error-text"
                      *ngIf="shouldShowExpirationDateError() "
                    >
                      Fecha inválida o vencida
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="tel"
                      inputmode="numeric"
                      autocomplete="cc-csc"
                      class="form-input"
                      [ngClass]="{ 'is-invalid': shouldShowCVVError() }"
                      mask="000"
                      placeholder="CVV"
                      name="cvc"
                      [(ngModel)]="paymentInfo.cvc"
                      (ngModelChange)="onCVVInput($event)"
                      (blur)="validationTouched.cvc = true"
                    />
                    <div class="error-text" *ngIf="shouldShowCVVError()">
                      Ingrese un CVV válido (3 dígitos)
                    </div>
                  </div>
                </div>

                <!-- Mobile Design - Card number above, expiry/CVV below connected -->
                <div class="form-group card-number-group mobile-full-width">
                  <span
                    class="material-symbols-outlined card-icon"
                    *ngIf="!detectedCardBrand"
                    >credit_card</span
                  >
                  <img
                    *ngIf="detectedCardBrand === 'visa'"
                    class="brand-icon"
                    src="assets/img/type-visa-card.png"
                    alt="Visa"
                  />
                  <img
                    *ngIf="detectedCardBrand === 'mastercard'"
                    class="brand-icon"
                    src="assets/img/type-mastercard-card.png"
                    alt="Mastercard"
                  />
                  <img
                    *ngIf="detectedCardBrand === 'amex'"
                    class="brand-icon"
                    src="assets/img/type-amex-card.png"
                    alt="Amex"
                  />
                  <img
                    *ngIf="detectedCardBrand === 'discover'"
                    class="brand-icon discover-icon"
                    src="assets/img/discover_card-logo.png"
                    alt="Discover"
                  />
                  <input
                    type="tel"
                    inputmode="numeric"
                    autocomplete="cc-number"
                    class="form-input card-number"
                    [ngClass]="{ 'is-invalid': shouldShowCardNumberError() }"
                    mask="0000 0000 0000 0000"
                    placeholder="1234 5678 9012 3456"
                    name="cardNumberMobile"
                    [(ngModel)]="paymentInfo.card"
                    (ngModelChange)="onCardInput($event)"
                    (focusout)="
                      searchCardDiscounts(); validationTouched.card = true
                    "
                    (input)="onCardInputMobile($event)"
                    maxlength="19"
                  />
                  <span class="material-symbols-outlined camera-icon"
                    >photo_camera</span
                  >
                </div>

                <!-- Mobile Design - Expiry Date and CVV connected -->
                <div class="card-details-row mobile-connected">
                  <div class="form-group expiration-date-group">
                    <input
                      type="tel"
                      inputmode="numeric"
                      autocomplete="cc-exp"
                      class="form-input"
                      [ngClass]="{
                        'is-invalid': shouldShowExpirationDateError()
                      }"
                      mask="00/00"
                      placeholder="MM/AA"
                      name="expDateMobile"
                      [(ngModel)]="paymentInfo.expDate"
                      (ngModelChange)="onExpDateInput($event)"
                      (keyup)="onExpDateKeyUp($event)"
                      (input)="onExpDateInputMobile($event)"
                      (blur)="validationTouched.expDate = true"
                      maxlength="5"
                    />
                    <div
                      class="error-text"
                      *ngIf="
                        shouldShowExpirationDateError() &&
                        !isExpirationDateExpired
                      "
                    >
                      Fecha inválida o vencida
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="tel"
                      inputmode="numeric"
                      autocomplete="cc-csc"
                      class="form-input"
                      [ngClass]="{ 'is-invalid': shouldShowCVVError() }"
                      mask="000"
                      placeholder="CVV"
                      name="cvcMobile"
                      [(ngModel)]="paymentInfo.cvc"
                      (ngModelChange)="onCVVInput($event)"
                      (input)="onCVVInputMobile($event)"
                      (blur)="validationTouched.cvc = true"
                      maxlength="3"
                    />
                  </div>
                </div>

                <div class="amex-warning" *ngIf="detectedCardBrand === 'amex'">
                  <span class="material-symbols-outlined warning-icon"
                    >warning</span
                  >
                  No aceptamos AMEX. Favor intentar con Visa o MasterCard
                </div>

                <div class="form-group cardholder-name-group">
                  <label
                    for="cardNumberName"
                    class="card-payment-subtitle subtitle-gray"
                    >Nombre del titular de tarjeta</label
                  >
                  <input
                    type="text"
                    class="form-input cardholder-name-input"
                    [ngClass]="{
                      'is-invalid': shouldShowCardholderNameError()
                    }"
                    id="cardNumberName"
                    name="cardholderName"
                    placeholder="James Bond"
                    [(ngModel)]="paymentInfo.name"
                    (ngModelChange)="onCardholderNameInput($event)"
                    (blur)="validationTouched.cardholderName = true"
                  />
                  <div
                    class="error-text"
                    *ngIf="shouldShowCardholderNameError()"
                  >
                    Ingrese el nombre del titular de la tarjeta (solo letras)
                  </div>
                </div>
              </form>

              <!-- Step-up verification: only rendered when the backend asks for it -->
              <div class="challenge-box mt-4" *ngIf="challengeRequired">
                <p class="challenge-text">
                  Por seguridad necesitamos verificar que no eres un robot antes
                  de procesar este pago.
                </p>
                <re-captcha
                  (resolved)="onChallengeResolved($event)"
                ></re-captcha>
              </div>

              <!-- Action Buttons -->
              <div class="action-buttons mt-4">
                <button
                  class="btn btn-primary btn-checkout more-rounded"
                  type="button"
                  (click)="proceedPayment()"
                  [disabled]="
                    !buttonStatus.checkout ||
                    !isFormValid() ||
                    (challengeRequired && !challengeToken)
                  "
                  style="
                    min-height: 38px !important;
                    max-height: 38px !important;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  Pagar ahora
                </button>
              </div>

              <!-- Terms and Conditions -->
              <p class="terms-text">
                Al realizar esta compra usted acepta los
                <strong
                  role="button"
                  tabindex="0"
                  data-bs-toggle="modal"
                  data-bs-target="#usageTerms"
                  >Términos de uso</strong
                >
                y las
                <strong
                  role="button"
                  tabindex="0"
                  data-bs-toggle="modal"
                  data-bs-target="#returnPolicies"
                  >Políticas de devolución</strong
                >
              </p>
              <p class="recaptcha-terms">
                Este sitio está protegido por reCAPTCHA
              </p>
            </div>
          </section>
        </div>

        <app-cybersource-authentication-required-modal></app-cybersource-authentication-required-modal>
      </div>
    </section>

    <!-- Right Column - Order Summary -->
    <aside class="checkout-right-column" [class.free-event-right]="eventFree">
      <!-- Mobile Compact Version -->
      <div
        class="order-summary-mobile-compact"
        [class.hidden]="isOrderSummaryExpanded"
      >
        <div class="compact-event-info">
          <div class="compact-event-image">
            <img [src]="getEventImageUrl()" alt="Event" class="event-img" />
          </div>
          <div class="compact-event-details">
            <h3 class="compact-event-title">{{ event.name }}</h3>
            <div class="compact-event-meta">
              <span class="ticket-count">{{ getTicketTypeSummary() }}</span>
            </div>
          </div>
        </div>
        <div class="compact-right-section">
          <button class="expand-button" (click)="toggleOrderSummary()">
            <span
              class="material-symbols-outlined"
              [class.rotated]="isOrderSummaryExpanded"
            >
              expand_more
            </span>
          </button>
          <span class="event-total"
            >RD${{
              (this.paymentInfo.secured
                ? this.orderPrice.securedTotal
                : this.orderPrice.total
              ) | number
            }}</span
          >
        </div>
      </div>

      <!-- Full Order Summary (Hidden by default on mobile) -->
      <div class="order-summary" [class.expanded]="isOrderSummaryExpanded">
        <!-- Mobile Collapse Button -->
        <div class="mobile-collapse-header" *ngIf="isOrderSummaryExpanded">
          <button class="collapse-button" (click)="toggleOrderSummary()">
            <span class="material-symbols-outlined"> expand_less </span>
          </button>
        </div>

        <!-- Event Details Card -->
        <section class="event-details">
          <div class="event-card">
            <div class="event-image">
              <img [src]="getEventImageUrl()" alt="Event" class="event-img" />
            </div>
            <div class="event-info">
              <h3 class="event-title">{{ event.name }}</h3>
              <div class="event-meta">
                <div class="event-meta-item">
                  <!-- <span class="event-icon">📅</span> -->
                  <span>{{
                    dates[0] | dateFormat : 'D MMMM YYYY' | titlecase
                  }}</span>
                </div>
                <div class="event-meta-item">
                  <!-- <span class="event-icon">⏰</span> -->
                  <span>{{ dates[0] | dateFormat : 'h:mm A' }}</span>
                </div>
                <div class="event-location" *ngFor="let place of places">
                  <!-- <span class="event-icon">📍</span> -->
                  <span>{{ place }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="ticket-breakdown">
          <div class="ticket-list">
            <ng-container
              *ngFor="
                let ticketType of selectedTicketTypes;
                let index = index;
                let isLast = last
              "
            >
              <div class="ticket-item">
                <div class="ticket-info">
                  <p class="ticket-title tw-font-medium">
                    {{ ticketType.name }}
                    <span class="ticket-qty"
                      >x {{ getProductByTicketType(ticketType.id).qty }}</span
                    >
                  </p>

                  <div class="ticket-price-unit">
                    {{
                      eventFree || ticketType.isFree
                        ? ''
                        : 'RD$' + ((products[index].donation_amount_per_ticket || ticketType.price) | number)
                    }}
                  </div>

                  <div
                    class="ticket-seats"
                    *ngIf="
                      selectedSeats[ticketType.id] &&
                      selectedSeats[ticketType.id].length > 0
                    "
                  >
                    <span class="seats-text">
                      Asientos: {{ selectedSeats[ticketType.id].join(', ') }}
                    </span>
                  </div>
                </div>

                <div class="ticket-total">
                  {{
                    eventFree || ticketType.isFree
                      ? 'GRATIS'
                      : 'RD$' +
                        ((products[index].donation_amount_per_ticket || ticketType.price) * products[index].qty | number)
                  }}
                </div>
              </div>
            </ng-container>
          </div>
        </section>

        <!-- Discount Code -->
        <section class="discount-section" *ngIf="!eventFree">
          <div class="discount-input-group">
            <input
              type="text"
              class="discount-input"
              placeholder="Código de descuento"
              [value]="couponCode"
              (keyup)="handleCouponCodeChange($event)"
            />
            <button
              class="btn btn-secondary"
              type="button"
              (click)="applyCoupon()"
              [disabled]="!buttonStatus.coupon"
            >
              Aplicar
            </button>
          </div>

          <!-- Coupon Status Messages -->
          <div class="coupon-messages">
            <span class="coupon-valid" *ngFor="let coupon of codeCoupons">
              {{ 'CUPÓN VÁLIDO POR ' + coupon.discount + '% DE DESCUENTO' }}
            </span>
            <span class="coupon-invalid" *ngIf="couponError">
              {{ couponError }}
            </span>
          </div>
        </section>

        <!-- Price Summary -->
        <section class="price-summary" *ngIf="!eventFree">
          <div class="price-list">
            <div class="price-row">
              <span>Subtotal</span>
              <span class="price-amount subtotal-price"
                >RD${{ orderPrice.orderAmount | number }}</span
              >
            </div>
            <div class="price-row">
              <span>Cargo por servicio</span>
              <span class="price-amount service-price"
                >RD${{ orderPrice.fees.serviceFee | number }}</span
              >
            </div>
            <div class="price-row">
              <div class="insurance-toggle">
                <div class="toggle-switch">
                  <input
                    type="checkbox"
                    [checked]="paymentInfo.secured"
                    (change)="
                      paymentInfo.secured
                        ? removeInsuranceFee()
                        : applyInsuranceFee()
                    "
                    id="insuranceToggle"
                  />
                  <label for="insuranceToggle" class="toggle-label"></label>
                </div>
                <label class="price-label" for="insuranceToggle"
                  >Seguro de compra</label
                >
                <div class="payment-tooltip">
                  <span
                    class="material-symbols-outlined info-icon"
                    (mouseenter)="showTooltip($event, 'tooltip-bubble--wide')"
                    (mouseleave)="hideTooltip($event, 'tooltip-bubble--wide')"
                    (touchstart)="
                      showTooltipTouch($event, 'tooltip-bubble--wide')
                    "
                    (touchend)="
                      hideTooltipTouch($event, 'tooltip-bubble--wide')
                    "
                    >info</span
                  >
                  <div class="tooltip-bubble tooltip-bubble--wide">
                    Asegura tu compra y obten el 100% del valor de tus entradas
                    en caso de que no puedas asistir al evento.
                    <span class="tooltip-note"
                      >Ciertas condiciones aplican.</span
                    >
                  </div>
                </div>
              </div>
              <span class="price-amount insurance-price"
                >RD${{ orderPrice.fees.insuranceFee | number }}</span
              >
            </div>

            <!-- Card Discounts -->
            <div class="price-row discount-row" *ngIf="cardCoupon">
              <span>
                Descuentos ({{ this.cardCoupon.name }} -{{
                  this.cardCoupon.discount
                }}%)
              </span>
              <span class="price-amount discount">
                -RD${{
                  (this.orderPrice.orderAmount / 100) * this.cardCoupon.discount
                    | number
                }}
              </span>
            </div>

            <!-- Coupon Discounts -->
            <div class="price-row discount-row" *ngIf="codeCoupons.length">
              <span>Cupón ({{ couponsNames }}) aplicado</span>
              <span class="price-amount discount">
                -RD${{
                  orderPrice.discounted - getDiscountedByCardDiscount() | number
                }}
              </span>
            </div>
          </div>
        </section>

        <!-- Total -->
        <section class="total-section" *ngIf="!eventFree">
          <div class="total-row">
            <span class="total-label">Total</span>
            <span class="total-amount">
              RD${{
                (this.paymentInfo.secured
                  ? this.orderPrice.securedTotal
                  : this.orderPrice.total
                ) | number
              }}
            </span>
          </div>
        </section>
      </div>
    </aside>
  </div>
</main>

<!-- Loading Modal -->
<core-loading></core-loading>

<!-- Hidden Elements -->
<app-three-dschallenge #threeChallengeModal></app-three-dschallenge>
<div id="3dscontainer" [innerHtml]="threeDSForm"></div>

<iframe
  id="cardinal_collection_iframe"
  name="collectionIframe"
  height="10"
  width="10"
  style="display: none"
></iframe>

<form id="cardinal_collection_form" method="POST" target="collectionIframe">
  <input id="cardinal_collection_form_input" type="hidden" name="JWT" />
</form>

<form id="step-up-form" target="step-up-iframe" method="post">
  <input id="step-up-form-input" type="hidden" name="JWT" />
  <input id="step-up-form-input-reference-id" type="hidden" name="MD" />
</form>

<button
  id="purchaseAuthenticationBtn"
  data-bs-toggle="modal"
  data-bs-target="#purchaseAuthentication"
  class="btn p-0 py-2 pe-3 link-dark"
></button>


<!-- Loading and Modals -->
<app-return-policies-modal></app-return-policies-modal>
<app-usage-terms-modal></app-usage-terms-modal>
